import React from 'react';
import '../../../assets/scss/_reports.scss';
import SummaryTableHeader from './SummaryTableHeader';
import AnxietyRow from './TableRows/AnxietyRow';
import ConcernsRow from './TableRows/ConcernsRow';
import ManiaRow from './TableRows/ManiaRow';
import SubstanceUseRow from './TableRows/SubstanceUseRow';

const SummaryTable = ({ advanceReport }) => {
  return (
    <div className="summary-table container mb-2 mt-4">
      <div aria-describedby="caption" className="table w-full border-collapse" role="grid">
        <SummaryTableHeader />
        <div className="table-row-group py-2">
          <AnxietyRow advanceReport={advanceReport} />
          <ManiaRow advanceReport={advanceReport} />
          <SubstanceUseRow advanceReport={advanceReport} />
          <ConcernsRow advanceReport={advanceReport} />
        </div>
      </div>
    </div>
  )
}

export default SummaryTable;